import { createContext } from 'react'
import { Partners } from '../types/partners'

type PartnerContextType = {
  partner: Partners
}

export const PartnerContext = createContext<PartnerContextType>({ partner: Partners.DEFAULT })
